'use strict';

import {EwSiteApp} from "./ewsiteapp.js";

EwSiteApp.controller('BasicErrorInfoCtrl', ["notify", "jsDataService", function(notify, jsDataService){
	let info = jsDataService.get('pageInfos', []);
	let error = jsDataService.get('pageErrors', []);
	if(info.length > 0){
		notify(info);
	}
	if(error.length > 0){
		notify(error, true);
	}
}]);